import { render, staticRenderFns } from "./Funding.vue?vue&type=template&id=c70707d4&scoped=true"
import script from "./Funding.vue?vue&type=script&lang=js"
export * from "./Funding.vue?vue&type=script&lang=js"
import style0 from "./Funding.vue?vue&type=style&index=0&id=c70707d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70707d4",
  null
  
)

export default component.exports